import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';

/**
 * Компонент боковой панели с русскими историческими единицами измерения
 */
const RussianDistancesSidebar = ({ setFormData, unitDefinitions }) => {
  // Исторические русские единицы измерения
  const russianUnits = [
    {
      name: 'Верста',
      unit: 'verst',
      equivalent: { value: 1.0668, unit: 'km' },
      description: 'Одна из основных русских мер длины, равная 500 саженям'
    },
    {
      name: 'Сажень',
      unit: 'sazhen',
      equivalent: { value: 2.1336, unit: 'm' },
      description: 'Русская мера длины, равная трём аршинам (семи футам)'
    },
    {
      name: 'Аршин',
      unit: 'arshin',
      equivalent: { value: 71.12, unit: 'cm' },
      description: 'Старинная русская мера длины, равная 16 вершкам'
    },
    {
      name: 'Вершок',
      unit: 'vershok',
      equivalent: { value: 4.445, unit: 'cm' },
      description: 'Старинная русская мера длины, равная ширине двух пальцев'
    }
  ];
  
  // Обработчик выбора единицы измерения
  const handleUnitSelect = (unit) => {
    setFormData(prev => ({
      ...prev,
      fromUnit: unit,
      toUnit: unit === 'km' ? 'verst' : 'km' // Для удобства выбираем противоположную единицу
    }));
  };
  
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <BookOpen className="w-5 h-5 mr-2 text-amber-500" />
        Исторические русские меры
      </h3>
      
      <div className="space-y-4">
        {russianUnits.map((item, index) => {
          const unitInfo = unitDefinitions[item.unit];
          const equivalentUnitInfo = unitDefinitions[item.equivalent.unit];
          
          return (
            <div 
              key={index}
              className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-100 dark:border-amber-800"
            >
              <div className="flex justify-between items-center mb-1">
                <h4 className="font-medium text-amber-800 dark:text-amber-300">
                  {item.name}
                </h4>
                <button
                  onClick={() => handleUnitSelect(item.unit)}
                  className="text-xs px-2 py-1 bg-amber-100 dark:bg-amber-800 text-amber-700 dark:text-amber-300 rounded hover:bg-amber-200 dark:hover:bg-amber-700 transition-colors"
                >
                  Выбрать
                </button>
              </div>
              
              <p className="text-sm text-amber-700 dark:text-amber-400 mb-2">
                {item.description}
              </p>
              
              <div className="flex items-center text-sm text-amber-600 dark:text-amber-400">
                <span>1 {unitInfo?.shortName || item.unit}</span>
                <ArrowRight className="w-3 h-3 mx-1" />
                <span className="font-medium">{item.equivalent.value} {equivalentUnitInfo?.shortName || item.equivalent.unit}</span>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="mt-5 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
          Знаете ли вы?
        </div>
        <p className="text-xs text-gray-600 dark:text-gray-400">
          В русской литературе XIX века часто встречаются старинные меры длины. Например, в известной поговорке «Семь вёрст до небес и всё лесом» или в выражении «Коломенская верста» — так называли очень высокого человека.
        </p>
      </div>
    </div>
  );
};

export default RussianDistancesSidebar;